var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.08 20H5.28C4.575 20 4 19.425 4 18.72V7.20001C4 6.49501 4.575 5.92001 5.28 5.92001H18.08C18.785 5.92001 19.36 6.49501 19.36 7.20001V18.72C19.36 19.425 18.785 20 18.08 20Z",
    stroke: "#627790",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55981 4V7.84",
    stroke: "#627790"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7998 4V7.84",
    stroke: "#627790"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.76001H19.36",
    stroke: "#627790",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48006 11.68H9.76006V12.96H8.48006V11.68Z",
    fill: "#627790"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 11.68H12.32V12.96H11.04V11.68Z",
    fill: "#627790"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 11.68H14.8799V12.96H13.5999V11.68Z",
    fill: "#627790"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1602 11.68H17.4402V12.96H16.1602V11.68Z",
    fill: "#627790"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48006 14.24H9.76006V15.52H8.48006V14.24Z",
    fill: "#627790"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92017 14.24H7.20017V15.52H5.92017V14.24Z",
    fill: "#627790"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 14.24H12.32V15.52H11.04V14.24Z",
    fill: "#627790"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 14.24H14.8799V15.52H13.5999V14.24Z",
    fill: "#627790"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48006 16.8H9.76006V18.08H8.48006V16.8Z",
    fill: "#627790"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92017 16.8H7.20017V18.08H5.92017V16.8Z",
    fill: "#627790"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 16.8H12.32V18.08H11.04V16.8Z",
    fill: "#627790"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1602 14.24H17.4402V15.52H16.1602V14.24Z",
    fill: "#627790"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/datepicker.bcac410902dfeca29e707c391df941a2.svg";
export { ForwardRef as ReactComponent };